import React from 'react';
import { Settings } from 'lucide-react';

function PrintSettings({ printerType, onPrinterTypeChange }) {
  return (
    <div className="bg-white rounded-xl border border-slate-200 p-4 mb-4">
      <div className="flex items-center gap-3 mb-3">
        <Settings className="w-5 h-5 text-[#B1336E]" />
        <h3 className="text-base font-bold text-slate-900 font-montserrat">
          Tipo de Impresora
        </h3>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <button
          onClick={() => onPrinterTypeChange('a4')}
          className={`p-4 rounded-lg border-2 transition-all duration-200 text-left ${
            printerType === 'a4'
              ? 'border-[#B1336E] bg-[#B1336E]/5'
              : 'border-slate-200 hover:border-slate-300'
          }`}
        >
          <div className="flex items-center gap-2 mb-1">
            <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${
              printerType === 'a4' ? 'border-[#B1336E]' : 'border-slate-300'
            }`}>
              {printerType === 'a4' && (
                <div className="w-3 h-3 rounded-full bg-[#B1336E]"></div>
              )}
            </div>
            <span className="font-bold text-slate-900 font-montserrat">
              Impresora A4
            </span>
          </div>
          <p className="text-xs text-slate-600 font-montserrat ml-7">
            Papel estándar A4 (210 × 297 mm)
            <br />
            8 etiquetas por hoja
          </p>
        </button>

        <button
          onClick={() => onPrinterTypeChange('thermal')}
          className={`p-4 rounded-lg border-2 transition-all duration-200 text-left ${
            printerType === 'thermal'
              ? 'border-[#B1336E] bg-[#B1336E]/5'
              : 'border-slate-200 hover:border-slate-300'
          }`}
        >
          <div className="flex items-center gap-2 mb-1">
            <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${
              printerType === 'thermal' ? 'border-[#B1336E]' : 'border-slate-300'
            }`}>
              {printerType === 'thermal' && (
                <div className="w-3 h-3 rounded-full bg-[#B1336E]"></div>
              )}
            </div>
            <span className="font-bold text-slate-900 font-montserrat">
              Impresora Térmica
            </span>
          </div>
          <p className="text-xs text-slate-600 font-montserrat ml-7">
            Xprinter XP-365B (80mm ancho)
            <br />
            1 etiqueta por rollo
          </p>
        </button>
      </div>
    </div>
  );
}

export default PrintSettings;